export default "__VITE_ASSET__Z4hqgC_O__"